<template>
    <div>
        <ul
            class="timeline timeline-alt"
            v-if="selectedMerchant.messagePaginator && selectedMerchant.messagePaginator.data && selectedMerchant.messagePaginator.data.length > 0"
        >
            <li
                class="timeline-event mb-1"
                v-for="message in selectedMerchant.messagePaginator.data"
                :key="message.id"
            >
                <div
                    class="timeline-event-icon bg-danger d-flex align-items-center justify-content-center"
                    v-if="message.type == 'email'"
                >
                    <i class="fa fa-envelope"></i>
                </div>
                <div
                    class="timeline-event-icon bg-info d-flex align-items-center justify-content-center"
                    v-if="message.type == 'note'"
                >
                    <i class="far fa-sticky-note"></i>
                </div>
                <div
                    class="timeline-event-icon bg-primary d-flex align-items-center justify-content-center"
                    v-if="message.type == 'text'"
                >
                    <i class="far fa-comment"></i>
                </div>
                <div
                    class="timeline-event-icon bg-secondary d-flex align-items-center justify-content-center"
                    v-if="message.type == 'feed'"
                >
                    <i class="fab fa-stack-exchange"></i>
                </div>
                <div
                    class="timeline-event-icon d-flex align-items-center justify-content-center"
                    :class="
						message.subject == 'Outbound Call'
							? 'bg-info'
							: 'bg-warning'
					"
                    v-if="message.type == 'phone' || message.type == 'call'"
                >
                    <i class="fa fa-phone-alt d-flex align-items-center justify-content-center"></i>
                </div>
                <div
                    class="timeline-event-block block js-appear-enabled animated fadeIn"
                    data-toggle="appear"
                >
                    <div class="block-header block-header-default">
                        <h3 class="block-title">{{ message.title }}</h3>
                        <div class="block-options">
                            <div class="timeline-event-time block-options-item font-size-sm font-w600">
                                <span :title="message.date">{{
									Bandwango.dateToLocal(message.date, true)
								}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="block-content">
                        <div class="font-size-sm push">
                            <div class="message-container">
                                <p class="mb-0" v-if="!message.readMore">
                                    {{Bandwango.truncateFilter(message.content, message.title == 'Note' ? maxNoteLength : maxMessageLength) }}
                                    <span v-if="truncatedMessage(message)" class="ml-1 btn btn-light btn-sm" v-on:click="(event) => expandHandler(event, message)">Read More</span>
                                </p>
                                <p class="mb-0" v-else >
									{{ message.content }}
									<span v-if="truncatedMessage(message)" class="ml-1 btn btn-light btn-sm" v-on:click="(event) => collapseHandler(event, message)">Read Less</span>
								</p>
                            </div>
                            <div class="full-width m-1 p-1 border" v-if="message.notes && message.notes.length">
                                <div class="full-width m-1" v-for="note in message.notes" :key="note.id">
                                    <i class="fa fa-file mr-1"></i><small>{{note.userName }} - <a class="noteDate" href="#" onclick="return false;" data-toggle="tooltip" :title="Bandwango.dateToLocal(note.created_at, false, 'MMMM Do YYYY, h:mm:ss a')">{{ Bandwango.dateToLocal(note.created_at, true)}}</a></small><br>
                                    <span class="font-size-sm ml-3" v-html="note.message"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li
                class="timeline-event pl-5"
                v-if="selectedMerchant.to < selectedMerchant.total"
            >
                <div
                    class="btn btn-sm w-100 border"
                    @click="$emit('get-merchant-logs', merchant)"
                >
                    Load More
                </div>
            </li>
        </ul>
        <div v-else>I'm not seeing any notes for: <b>{{selectedMerchant.name}}</b></div>
    </div>
</template>

<script>
export default {
    methods: {
      expandHandler : function(event, message){
        this.$emit('expand-message', message);
      },
	  collapseHandler: function(event, message){
		  this.$emit('collapse-message', message);
	  },
	  truncatedMessage: function(message){
		  return message.content && ((message.title != 'Note' &&  message.content.length > this.maxMessageLength) || (message.title == 'Note' &&  message.content.length > this.maxNoteLength));
	  },	
	  
    },

    props: {
        venueId: { type: Number },
        campaign: {
            type: Object,
            default() {
                return []
            },
        },
        venue: {
            type: Object,
            default() {
                return []
            },
        },
        allLogs: {
            type: Array|Object,
            default() {
                return []
            },
        },
        selectedMerchant: { type: Object },
        showForm: { type: Boolean },
		maxMessageLength: { type: Number, default: 0 },
		maxNoteLength: { type: Number, default: 200 },
    },
}
</script>
